import type {TextProps, ThemeColorPath, ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import {smtpCredentialsTestStatus} from '../constants/smtpCredentialsTestStatus';
import type {SmtpTestResultStatus} from '../types/SmtpTestResultStatus';

export function getSmtpTestStatusPresentation(status: SmtpTestResultStatus) {
  return match(status)
    .returnType<{icon: ThemeIconKey; color: ThemeColorPath; textColor: TextProps['color']}>()
    .with(smtpCredentialsTestStatus.done, () => ({
      icon: 'action/check_circle',
      color: 'severity.success',
      textColor: 'primary',
    }))
    .with(smtpCredentialsTestStatus.failed, () => ({
      icon: 'navigation/cancel',
      color: 'severity.danger',
      textColor: 'danger',
    }))
    .with(smtpCredentialsTestStatus.warning, () => ({
      icon: 'alert/warning',
      color: 'severity.warning',
      textColor: 'primary',
    }))
    .with(smtpCredentialsTestStatus.skip, () => ({
      icon: 'content/remove',
      color: 'text.secondary',
      textColor: 'secondary',
    }))
    .exhaustive();
}
